/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';

// import { StoreContext } from '../../utils/store';
import { FREQUENCIES } from '../../constants';

// eslint-disable-next-line import/order
import frequencypickercss from './frequencypicker.css';

function FrequencyPicker({
  title,
  placeHolder,
  value,
  onValueChange,
  errorMessage,
  className,
}) {
  const getSelectedName = name => {
    const selected = FREQUENCIES.map(item => {
      if (name === item.value) {
        return item.name;
      }
      return null;
    });
    if (
      selected.every(v => {
        return v === null;
      })
    ) {
      return placeHolder;
    }
    return selected;
  };

  const selectedName = getSelectedName(value);

  return (
    <div
      className={
        errorMessage
          ? 'frequency-picker-wrapper error ' + className
          : 'frequency-picker-wrapper ' + className
      }
    >
      {title ? <header>{title}</header> : false}
      <div>
        <DropdownButton
          onSelect={onValueChange}
          className="frequency-picker"
          title={selectedName || placeHolder}
        >
          {FREQUENCIES.map(item => (
            <Dropdown.Item key={item.id} id={item.id} eventKey={item.value}>
              {item.name}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </div>
      {errorMessage && <p className="error"> {errorMessage} </p>}
    </div>
  );
}

FrequencyPicker.propTypes = {
  title: PropTypes.string,
  placeHolder: PropTypes.string,
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  className: PropTypes.string,
};

export default FrequencyPicker;
